var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"custom-nav"},[_c('Dropdown',{attrs:{"title":"ΔΩΜΑΤΙΑ","titlen":"ACCOMMODATION","items":_vm.services,"itemsen":_vm.servicesen}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }